<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-btn text icon color="green">
            <v-icon @click="$router.go(-1)">mdi-keyboard-backspace</v-icon>
          </v-btn>

          <v-icon v-if="this.newMode">mdi-plus</v-icon>
          <v-icon v-if="this.queryMode">mdi-magnify</v-icon>
          <v-icon v-if="this.reviewMode">mdi-pencil</v-icon>
          <v-toolbar-title v-if="this.newMode">Create Treaty Detail</v-toolbar-title>
          <v-toolbar-title v-if="this.queryMode">View Treaty Detail</v-toolbar-title>
          <v-toolbar-title v-if="this.reviewMode">Edit Treaty Detail</v-toolbar-title>

        </v-toolbar>
        <v-card-text>
          <v-flex xs12 class="mt-3">
            <message :messages="messages"></message>
          </v-flex>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-autocomplete
                  :items="acctTypeList"
                  :label="labels.riType"
                  v-model="ttyDetForm.riType"
                  item-text="label"
                  item-value="value"
                  data-vv-name="riType"
                  :data-vv-as="labels.riType"
                  :error-messages="errors.collect('riType')"
                  v-validate="'entry'"
                  :disabled="reviewMode"
                ></v-autocomplete>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.riType }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.riType }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-text-field
                  :label="labels.ttyNo"
                  v-model="ttyDetForm.ttyNo"
                  item-text="label"
                  item-value="value"
                  data-vv-name="ttyNo"
                  :data-vv-as="labels.ttyNo"
                  :error-messages="errors.collect('ttyNo')"
                  v-validate="'required'"
                  :disabled="reviewMode"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.ttyNo }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.ttyNo }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-text-field
                  :label="labels.uwYr"
                  v-model="ttyDetForm.uwYr"
                  item-text="label"
                  item-value="value"
                  data-vv-name="uwYr"
                  :data-vv-as="labels.uwYr"
                  :error-messages="errors.collect('uwYr')"
                  v-validate="checkYearRange"
                  :disabled="reviewMode"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.uwYr }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.uwYr }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-text-field
                  :label="labels.pctNotCed"
                  v-model="ttyDetForm.pctNotCed"
                  item-text="label"
                  item-value="value"
                  data-vv-name="pctNotCed"
                  :data-vv-as="labels.pctNotCed"
                  :error-messages="errors.collect('pctNotCed')"
                  v-validate="'entry'"
                  :disabled="reviewMode"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.pctNotCed }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.pctNotCed }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-text-field
                  :label="labels.thTtyNo"
                  v-model="ttyDetForm.thTtyNo"
                  item-text="label"
                  item-value="value"
                  data-vv-name="thTtyNo"
                  :data-vv-as="labels.thTtyNo"
                  :error-messages="errors.collect('thTtyNo')"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.thTtyNo }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.thTtyNo }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-text-field
                  :label="labels.ttyName"
                  v-model="ttyDetForm.ttyName"
                  item-text="label"
                  item-value="value"
                  data-vv-name="ttyName"
                  :data-vv-as="labels.ttyName"
                  :error-messages="errors.collect('ttyName')"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.ttyName }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.ttyName }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <cal-picker
                  :label="labels.comDate"
                  v-model="ttyDetForm.comDate"
                  :error-messages="errors.collect('comDate')"
                  data-vv-name="comDate"
                  :data-vv-as="labels.comDate"
                  v-validate="'required'"
                ></cal-picker>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.comDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(ttyDetForm.comDate) }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <cal-picker
                  :label="labels.firstComDate"
                  v-model="ttyDetForm.firstComDate"
                  :error-messages="errors.collect('firstComDate')"
                  data-vv-name="firstComDate"
                  :data-vv-as="labels.firstComDate"
                  v-validate="'entry'"
                ></cal-picker>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.firstComDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(ttyDetForm.firstComDate) }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <cal-picker
                  :label="labels.expDate"
                  v-model="ttyDetForm.expDate"
                  :error-messages="errors.collect('expDate')"
                  data-vv-name="expDate"
                  :data-vv-as="labels.expDate"
                  v-validate="'required'"
                ></cal-picker>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.expDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(ttyDetForm.expDate) }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-text-field
                  :label="labels.abbrevTtyName"
                  v-model="ttyDetForm.abbrevTtyName"
                  item-text="label"
                  item-value="value"
                  data-vv-name="abbrevTtyName"
                  :data-vv-as="labels.abbrevTtyName"
                  :error-messages="errors.collect('abbrevTtyName')"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.abbrevTtyName }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.abbrevTtyName }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-autocomplete
                  :items="propNPropList"
                  :label="labels.propNProp"
                  v-model="ttyDetForm.propNProp"
                  item-text="label"
                  item-value="value"
                  data-vv-name="propNProp"
                  :data-vv-as="labels.propNProp"
                  :error-messages="errors.collect('propNProp')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.propNProp }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.propNProp }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-autocomplete
                  :items="ttyTypeList"
                  :label="labels.ttyType"
                  v-model="ttyDetForm.ttyType"
                  item-text="label"
                  item-value="value"
                  data-vv-name="ttyType"
                  :data-vv-as="labels.ttyType"
                  :error-messages="errors.collect('ttyType')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.ttyType }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.ttyType }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-text-field
                  :label="labels.contact"
                  v-model="ttyDetForm.contact"
                  item-text="label"
                  item-value="value"
                  data-vv-name="contact"
                  :data-vv-as="labels.contact"
                  :error-messages="errors.collect('contact')"
                  v-validate="'entry'"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.contact }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.contact }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-text-field
                  v-model="ttyDetForm.mainTtyCls"
                  :label="labels.mainTtyCls"
                  :error-messages="errors.collect('mainTtyCls')"
                  data-vv-name="mainTtyCls"
                  :data-vv-as="labels.mainTtyCls"
                  append-icon="mdi-magnify"
                  readonly
                  @click:append="showMultiBusAnHelpList = true"/>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.mainTtyCls }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.mainTtyCls }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12></v-flex>

              <v-flex lg4 md4 xs12>
                <v-checkbox :label="labels.perGrsPrem" v-model="ttyDetForm.perGrsPrem" :disabled="queryMode"></v-checkbox>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-checkbox :label="labels.perNetPrem" v-model="ttyDetForm.perNetPrem" :disabled="queryMode"></v-checkbox>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-checkbox :label="labels.perAbsNetPrem" v-model="ttyDetForm.perAbsNetPrem" :disabled="queryMode"></v-checkbox>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-text-field
                  v-model="ttyDetForm.txfrTtyNo"
                  :label="labels.txfrTtyNo"
                  :error-messages="errors.collect('ttyDetForm.txfrTtyNo')"
                  data-vv-name="ttyDetForm.txfrTtyNo"
                  :data-vv-as="labels.txfrTtyNo"
                  append-icon="mdi-magnify"
                  readonly
                  @click:append="showTreatyNoHelpList = true"/>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.txfrTtyNo }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.txfrTtyNo }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-text-field
                  :label="labels.txfrUWYr"
                  v-model="ttyDetForm.txfrUWYr"
                  item-text="label"
                  item-value="value"
                  data-vv-name="txfrUWYr"
                  :data-vv-as="labels.txfrUWYr"
                  :error-messages="errors.collect('txfrUWYr')"
                  v-validate="'entry'"
                  :disabled="ttyDetForm.txfrTtyNo === undefined || ttyDetForm.txfrTtyNo === '' || ttyDetForm.txfrTtyNo === null"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.txfrUWYr }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.txfrUWYr }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-text-field
                  :label="labels.curr"
                  v-model="ttyDetForm.curr"
                  :error-messages="errors.collect('curr')"
                  data-vv-name="curr"
                  :data-vv-as="labels.curr"
                  v-validate="'entry'"
                  readonly
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="showCurrencyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.curr }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.curr }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-autocomplete
                  :items="clCutROffList"
                  :label="labels.clCutROff"
                  v-model="ttyDetForm.clCutROff"
                  item-text="label"
                  item-value="value"
                  data-vv-name="clCutROff"
                  :data-vv-as="labels.clCutROff"
                  :error-messages="errors.collect('clCutROff')"
                  v-validate="'required'"
                  @change="doClCutROff"
                ></v-autocomplete>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.clCutROff }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.clCutROff }}</div>
              </v-flex>

              <v-flex lg4 md4 xs12 v-if="!queryMode">
                <v-text-field
                  type="number"
                  :min="0"
                  :label="labels.rOffYr"
                  v-model="ttyDetForm.rOffYr"
                  item-text="label"
                  item-value="value"
                  data-vv-name="rOffYr"
                  :data-vv-as="labels.rOffYr"
                  :error-messages="errors.collect('rOffYr')"
                  v-validate="checkRunOff"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.rOffYr }}</v-subheader>
                <div class="queryValue">{{ ttyDetForm.rOffYr }}</div>
              </v-flex>
            </v-layout>

            <v-layout v-if="!newMode">
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="queryMode">
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex lg4 md4 xs12>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>

          </v-container>
        </v-card-text>

        <v-flex lg6 md12 xs12>
          <v-card-actions>
            <v-btn class="white--text error" @click.prevent="doClose" v-if="!queryMode">
              Cancel
              <v-icon right>mdi-exit-to-app</v-icon>
            </v-btn>
            <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave"  v-if="!queryMode">
              {{ newMode ? 'Create' : 'Save' }}
              <v-icon right>{{ newMode ? 'mdi-plus' : 'mdi-content-save' }}</v-icon>
            </v-btn>
            <v-btn class="white--text green" @click.prevent="doClose" v-if="queryMode">
              Back
              <v-icon right>mdi-exit-to-app</v-icon>
            </v-btn>
            <!-- <v-btn class="white--text primary" @click.prevent="doReviewMode" v-if="queryMode">
              Edit
              <v-icon right>mdi-pen</v-icon>
            </v-btn> -->
          </v-card-actions>
        </v-flex>
      </v-card>

      <v-dialog v-model="showMultiBusAnHelpList" width="900px">
        <multi-bus-an-help-list :mainTtyCls="ttyDetForm.mainTtyCls" :riType="ttyDetForm.riType"  @close="showMultiBusAnHelpList = false" @doAssign="doAssignBusAn($event)"></multi-bus-an-help-list>
      </v-dialog>

      <v-dialog v-model="showTreatyNoHelpList" width="900px">
        <txfrTtyNo-help-list @close="showTreatyNoHelpList = false" @assign-treaty-info="assignTreatyInfo"></txfrTtyNo-help-list>
      </v-dialog>

      <v-dialog v-model="showCurrencyHelpList" width="900px">
        <currency-help-list @close="showCurrencyHelpList = false" @assign-currency-info="assignCurrencyInfo"></currency-help-list>
      </v-dialog>

    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI } from '@/utils/ajax'
import { acctType, propNProp, ttyType, clCutROff } from '@/const/params'
import { formatDisplayDate } from '@/utils/date'
import TreatyNoHelpList from '@/components/core/common/dialog/TreatyNoHelpList'
import MultiBusAnHelpList from '@/components/core/common/dialog/MultiBusAnHelpList'
import CurrencyHelpList from '@/components/core/common/dialog/CurrencyHelpList'

export default {
  data() {
    return {
      labels: {
        riType: 'Inwards / Outwards',
        ttyNo: 'Treaty Reference',
        uwYr: 'Underwritting Year',
        pctNotCed: '% Not Ceded Out',
        thTtyNo: 'Their Treaty Reference',
        comDate: 'Commencement Date',
        firstComDate: 'First Commencement Date',
        expDate: 'Expiry Date',
        ttyName: 'Treaty Name',
        abbrevTtyName: 'Abbreviated Treaty Name',
        propNProp: 'Proportional or Non-Proportional',
        ttyType: 'Treaty Type',
        mainTtyCls: 'Main Business Class',
        contact: 'Our Contact Details',
        perGrsPrem: 'Premium GNA Permit Gross',
        perNetPrem: 'Premium GNA Permit Net',
        perAbsNetPrem: 'Premium GNA Permit Absolute Net',
        txfrTtyNo: 'Transfer Treaty Reference',
        txfrUWYr: 'Transfer Underwritting Year',
        curr: 'Currency',
        clCutROff: 'Clean-Cut or Run-Off',
        rOffYr: 'No. of Run-Off Years',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      ttyDetForm: {
        riType: 'O',
        ttyNo: undefined,
        uwYr: undefined,
        pctNotCed: 0,
        thTtyNo: undefined,
        comDate: undefined,
        firstComDate: undefined,
        expDate: undefined,
        ttyName: undefined,
        abbrevTtyName: undefined,
        propNProp: 'P',
        ttyType: undefined,
        mainTtyCls: '',
        contact: undefined,
        perGrsPrem: false,
        perNetPrem: false,
        perAbsNetPrem: false,
        txfrTtyNo: undefined,
        txfrUWYr: 0,
        curr: undefined,
        clCutROff: undefined,
        rOffYr: 0
      },
      prevTtyNo: false,
      currencies: {},
      treatyno: [],
      mainTreatyBusCls: [],
      // helplist
      showTreatyNoHelpList: false,
      showMultiBusAnHelpList: false,
      showCurrencyHelpList: false,
      // mode
      newMode: undefined,
      queryMode: undefined,
      reviewMode: undefined,
      submitting: false,
      rOffYrCheck: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined
    }
  },
  methods: {
    async doFetchTreatyDet() {
      const apiURI = this.treatyMenu.treatyDet
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            riType: this.treatyDetails.riType,
            ttyNo: this.treatyDetails.ttyNo,
            uwYr: this.treatyDetails.uwYr
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result
          if (data) {
            this.ttyDetForm.uwYr = data.uwYr
            this.ttyDetForm.pctNotCed = data.pctNotCed
            this.ttyDetForm.ttyNo = data.ttyNo
            this.ttyDetForm.thTtyNo = data.thTtyNo
            this.ttyDetForm.comDate = data.comDate
            this.ttyDetForm.firstComDate = data.firstComDate
            this.ttyDetForm.expDate = data.expDate
            this.ttyDetForm.ttyName = data.ttyName
            this.ttyDetForm.abbrevTtyName = data.abbrevTtyName
            this.ttyDetForm.propNProp = data.propNProp
            this.ttyDetForm.ttyType = data.ttyType
            this.ttyDetForm.mainTtyCls = data.mainTtyCls
            this.ttyDetForm.contact = data.contact
            this.ttyDetForm.perGrsPrem = data.perGrsPrem
            this.ttyDetForm.perNetPrem = data.perNetPrem
            this.ttyDetForm.perAbsNetPrem = data.perAbsNetPrem
            this.ttyDetForm.txfrTtyNo = data.txfrTtyNo
            this.ttyDetForm.txfrUWYr = data.txfrUWYr
            this.ttyDetForm.curr = data.curr
            this.ttyDetForm.clCutROff = data.clCutROff
            if (this.ttyDetForm.clCutROff === 'C') {
              this.rOffYrCheck = true
            }
            this.prevTtyNo = data.prevTtyNo
            this.ttyDetForm.rOffYr = data.rOffYr
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    },
    assignTreatyInfo(data) {
      this.ttyDetForm.txfrTtyNo = data.ttyNo
      this.showTreatyNoHelpList = false
    },
    assignCurrencyInfo(data) {
      this.ttyDetForm.curr = data.curr
      this.showCurrencyHelpList = false
    },
    doAssignBusAn(data) {
      this.ttyDetForm.mainTtyCls = []
      this.ttyDetForm.mainTtyCls = data.finalSelectedItems.toString()
    },
    doClose() {
      this.$router.push({ name: 'treatyDetails' })
    },
    doNewMode() {
      this.newMode = true
      this.queryMode = false
      this.reviewMode = false
    },
    doQueryMode() {
      this.newMode = false
      this.queryMode = true
      this.reviewMode = false
    },
    doReviewMode() {
      this.newMode = false
      this.queryMode = false
      this.reviewMode = true
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.treatyMenu.createTreatyDet
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.ttyDetForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doQueryMode()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.treatyMenu.updateTreatyDet
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.ttyDetForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doQueryMode()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doClCutROff() {
      this.resetMessages()
      if (this.ttyDetForm.clCutROff === 'C') {
        this.rOffYrCheck = true
        this.ttyDetForm.rOffYr = 1
      } else if (this.ttyDetForm.clCutROff === 'R' && this.ttyDetForm.rOffYr === 1) {
        this.rOffYrCheck = false
        this.ttyDetForm.rOffYr = 2
      } else {
        this.rOffYrCheck = false
        this.ttyDetForm.rOffYr = 2
      }
    },
    formatDisplayDate(date) {
      return formatDisplayDate(date)
    }
  },
  computed: {
    treatyDetails() {
      return this.$route.params.treatyDetails
    },
    tranMode() {
      return this.$route.params.tranMode
    },
    treatyMenu() {
      return this.$store.state.treatyParam.menu
    },
    ttyNoParam() {
      return this.$route.params.ttyNoParam
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach(function (key) {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    propNPropList() {
      let result = []
      Object.keys(propNProp).forEach(function (key) {
        const status = propNProp[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    ttyTypeList() {
      let result = []
      Object.keys(ttyType).forEach(function (key) {
        const status = ttyType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    clCutROffList() {
      let result = []
      Object.keys(clCutROff).forEach(function (key) {
        const status = clCutROff[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    checkYearRange() {
      const result = 'required|yearRange:' + this.ttyDetForm.uwYr
      return result
    },
    checkRunOff() {
      const result = 'required|runOffCheck:' + this.ttyDetForm.rOffYr + ',' + this.ttyDetForm.clCutROff
      return result
    }
  },
  created() {
    if (this.treatyDetails === undefined && this.tranMode === undefined) {
      this.doClose()
    } else {
      if (this.tranMode === 'New') {
        this.doNewMode()
      } else if (this.tranMode === 'Query') {
        this.doQueryMode()
        this.doFetchTreatyDet()
      } else if (this.tranMode === 'Review') {
        this.doReviewMode()
        this.doFetchTreatyDet()
      }
    }

    this.$validator.extend('yearRange', {
      getMessage(field, args) {
        return `${field} must be in the range of 1900 to 2099`
      },
      validate(value, args) {
        if (value) {
          if (value < 1900) {
            return false
          } else if (value > 2099) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    })

    this.$validator.extend('runOffCheck', {
      getMessage(field, args) {
        return `${field} must be greater than 1 for Run-Off`
      },
      validate(value, args) {
        if (args[1] === 'R') {
          if (value < 2) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    })
  },
  mixins: [
    MessageMixin,
    commonAjaxMixin
  ],
  components: {
    'multi-bus-an-help-list': MultiBusAnHelpList,
    'currency-help-list': CurrencyHelpList,
    'txfrTtyNo-help-list': TreatyNoHelpList
  },
  props: ['ttyDet']
}
</script>
